export const LISTING_STATE = {
  ELIGIBLE: 'ELIGIBLE',
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  PUBLISHING: 'PUBLISHING',
} as const;

export type ListingState = keyof typeof LISTING_STATE;

export const ONBOARDING_QUERY_PARAM = 'widget';
export const ONBOARDING_QUERY_VALUE = 'join';

export const IS24 = {
  HOST: {
    sandbox: 'https://www.sandbox-immobilienscout24.de',
    production: 'https://www.immobilienscout24.de',
  },
  PATHS: {
    meinImmobilien: '/meinkonto/meine-immobilien/immobilien',
    meinImmobilienOverview: '/meinkonto/meine-immobilien',
    homepage: '/',
  },
} as const;

export const resolveIS24BaseUrl = (): string =>
  IS24.HOST[window.location.hostname.includes('sandbox') ? 'sandbox' : 'production'];

export const resolveListingState = (status?: string, listingStatus?: string | null): ListingState => {
  if (listingStatus === LISTING_STATE.PUBLISHED || listingStatus === LISTING_STATE.PUBLISHING) {
    return LISTING_STATE.PUBLISHED;
  }
  if (listingStatus === LISTING_STATE.DRAFT || status !== LISTING_STATE.ELIGIBLE) {
    return LISTING_STATE.DRAFT;
  }
  return LISTING_STATE.ELIGIBLE;
};
